import useUser from "../store/user";
import Sidebar from "./Sidebar";

const Layout = (props) => {
  const { user } = useUser();

  return (
    <div className="w-full h-screen flex flex-col md:flex-row">
      {user && <Sidebar />}

      <div className="h-full w-full overflow-y-auto">{props.children}</div>
    </div>
  );
};

export default Layout;
